(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }
      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);
        this.disclosure.open = isLargeScreen || isConfirmNewsletter;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }
    customElements.define('footer-menu', FooterMenu);
  });

  // The Shop follow button uses its own shadow root, so regular footer CSS
  // does not reliably color its text. Keep the branded icon/background intact.
  function sportStyleShopFollowText() {
    const hosts = document.querySelectorAll('.footer--sport-modern.footer--sport-dark .footer-block__shop-follow shop-follow-button');
    hosts.forEach((host) => {
      if (host.dataset.sportFollowTextPending === '1') return;
      host.dataset.sportFollowTextPending = '1';
      let attempts = 0;
      function apply() {
        const root = host.shadowRoot;
        const button = root && root.querySelector('button');
        if (!button) return false;
        button.style.setProperty('color', '#ffffff', 'important');
        button.querySelectorAll('span').forEach((span) => {
          if (!span.closest('.follow-icon-wrapper')) {
            span.style.setProperty('color', '#ffffff', 'important');
          }
        });
        return true;
      }
      if (apply()) {
        delete host.dataset.sportFollowTextPending;
        return;
      }
      const timer = window.setInterval(() => {
        attempts += 1;
        if (!host.isConnected || apply() || attempts >= 32) {
          window.clearInterval(timer);
          delete host.dataset.sportFollowTextPending;
        }
      }, 250);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sportStyleShopFollowText, { once: true });
  } else {
    sportStyleShopFollowText();
  }
  document.addEventListener('shopify:section:load', sportStyleShopFollowText);

  } catch(e) { console.error(e); }
})();
})();
